/* The rail rests 8px off the right edge so its square outer corners sit outside
   the viewport and only the rounded inner edge shows.
   It deliberately does NOT move on hover: the old widget's rail (.webaskjess)
   was static, and a rail that slides under the cursor reads as a misclick.
   Don't re-add `transition: right` + `#ws-launcher:hover { right: 0 }`. */
#ws-launcher {
  position: fixed;
  top: 50%;
  right: -8px;
  transform: translateY(-50%);
  z-index: 999999;
}

.launcher {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  width: 46px;
  height: auto;
  padding: 15px 15px;
  background: var(--ws-primary, #2C2C2C);
  color: #ffffff;
  border: none;
  border-radius: 12px 0 0 12px;
  cursor: pointer;
  box-shadow: -4px 0 10px rgba(0,0,0,0.3);
  transition: box-shadow 0.3s ease;
  -webkit-tap-highlight-color: transparent;
}

.launcher:hover {
  box-shadow: -6px 0 15px rgba(0,0,0,0.4);
}

.icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  /* transform: rotate(180deg); */
}

.label {
  writing-mode: vertical-rl;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  white-space: nowrap;
}